module.exports = __webpack_public_path__ + "static/media/07.d140887a.jpg";